import React from "react";
import "../styles/ShowroomInfo.css";

function ShowroomInfo({ showroom, allShowrooms, travelInfo }) {
    // Kiểm tra xem danh sách allShowrooms có trạm dịch vụ nào đã được tính khoảng cách không
    const hasDistance = allShowrooms.some(item => item.distance !== undefined);
    
    return (
        <section className="showroom-info showroom-info-list">
            <div className="card card-list">
                <h3>
                    {hasDistance 
                        ? "Danh Sách Trạm Dịch Vụ (Tìm theo khoảng cách)" 
                        : "Danh Sách Trạm Dịch Vụ Toàn Quốc"}
                </h3>
                
                <div className="info-content info-content-list">
                    {allShowrooms.map((item, index) => (
                        <div key={index} className="info-row showroom-item">
                            {hasDistance && (
                                <div className="item-distance-badge">
                                    {item.distance} km
                                    {item.realDistance && <span className="real-distance-tag">Thực tế</span>}
                                </div>
                            )}
                            <div className="showroom-details">
                                <div className="showroom-name">
                                    <span className="label">Tên:</span>
                                    <span className="value">
                                        {item.name}
                                    </span>
                                </div>
                                <div className="showroom-address">
                                    <span className="label">Địa chỉ:</span>
                                    <span className="value">
                                        {item.address}
                                    </span>
                                </div>
                                {item.phone && (
                                    <div className="showroom-phone">
                                        <span className="label">Điện thoại:</span>
                                        <span className="value">
                                            <a href={`tel:${item.phone}`} className="phone-link">{item.phone}</a>
                                        </span>
                                    </div>
                                )}
                                {item.distance && (
                                    <div className="showroom-distance">
                                        <span className="label">Khoảng cách:</span>
                                        <span className="value distance-value">
                                            {item.distance} km
                                            {item.realDistance && <span className="distance-type">(Đường đi thực tế)</span>}
                                            {!item.realDistance && <span className="distance-type">(Đường chim bay)</span>}
                                        </span>
                                    </div>
                                )}
                                {item.duration && item.duration !== 'Không có dữ liệu' && (
                                    <div className="showroom-duration">
                                        <span className="label">Thời gian:</span>
                                        <span className="value duration-value">{item.duration}</span>
                                    </div>
                                )}
                                {hasDistance && (
                                    <div className="showroom-directions">
                                        <a
                                            href={`https://www.google.com/maps/dir/?api=1&destination=${item.lat},${item.lng}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="small-directions-btn"
                                        >
                                            <LocationIcon /> Chỉ đường
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                
                <div className="info-note">
                    <p>
                        {hasDistance 
                            ? "Danh sách trạm dịch vụ từ gần đến xa" 
                            : "Hãy nhấn \"Tìm Trạm Dịch Vụ Gần Nhất\" để tìm danh sách trạm dịch vụ gần nhất"}
                    </p>
                </div>
            </div>
        </section>
    );
}

const LocationIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
            fill="currentColor"
        />
    </svg>
);

export default ShowroomInfo;
